import { useCallback } from "react"

import { ensureLogin, useRoleInfo } from "@/user/session"

export const useCheckLogin = () => {
    const user = useRoleInfo()

    return useCallback(() => {
        if (user) {
            return true
        }
        ensureLogin()
        return false
    }, [user])
}
